<template>
<div class="chart-tooltip" :style="tooltipStyle" ref="tooltip">
	<div class="chart-tooltip-inner" v-if="tooltipModel && tooltipModel.dataPoints">
        <div class="rich-label" @mouseover="noDisplay = true">
            <span class="small">{{ richLabelTop }}</span>
            <p><strong>{{ richLabelBottom }}</strong></p>
        </div>
        <div class="body">
            <div class="chart-tooltip-stats">
	            <table>
	            	<tbody>
	            		<tr v-for="datapoint in tooltipModel.dataPoints">
	            			<th scope="row">{{ datasetLabels[datapoint.datasetIndex] }}</th>
	            			<td >{{ abbrNum(datapoint.value, 1) }}</td>
	            		</tr>
	            	</tbody>
	            </table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
	props: ['tooltip-model', 'tooltip-settings', 'dataset-labels', 'has-legends'],
	data() {
		return {
			tooltipHidden: false
		}
	},
	mounted() {
	},
	computed: {
		date() {
			return this.tooltipModel ? moment(this.tooltipModel.dataPoints[0].label)
				: moment()
		},
		richLabelTop() {
			let year = this.date.year()
			
			if (year && !isNaN(year)) {
				return year
			}

			try {
				let parts = this.tooltipModel.dataPoints[0].label.split("-")
				return parts[parts.length - 1]
			} catch(exception) {
				return ''
			}
		},
		mainScore() {
			return this.tooltipModel ?
				this.tooltipModel.dataPoints[0].yLabel : '0'
		},
		richLabelBottom() {
			let date = this.date.format('D MMM')

			if (date.toString() !== "Invalid date") {
				return date
			}

			try {
				return this.tooltipModel.dataPoints[0].label.split(" ")[0]
			} catch(exception) {
				//
			}
		},
		tooltipHeight() {
			let dependsOn = this.tooltipModel
			let height = this.$refs.tooltip.clientHeight

			if (this.hasLegends) {
				height -= 23
			}

			return height
		},
		tooltipStyle() {

			if (! this.tooltipModel) {
				return {}
			}

			if (! this.tooltipModel.dataPoints) {
				return {
					display: 'none'
				}
			}

			let topValue = this.tooltipModel.dataPoints[0].y - this.tooltipHeight

			return {
                opacity: this.tooltipHidden ? 0 : 1,
                position: 'absolute',
                left: this.tooltipModel.dataPoints[0].x - 50 + 'px',
                top: topValue + 'px',
                fontFamily: this.tooltipModel._bodyFontFamily,
                fontSize: this.tooltipModel.bodyFontSize + 'px',
                fontStyle: this.tooltipModel._bodyFontStyle,
                pointerEvents: 'none'
            }
		}
	},
	methods: {

	}
};
</script>
